// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 826 ? "__federation_expose_WorkspaceMgmtRoutes" : chunkId) + "." + {"25":"bc9770c9babc86b9","613":"d3b42ea9ab3b4cbd","696":"fe47c60ec42e28af","826":"b2c8d2d005183479"}[chunkId] + ".css";
};